import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import Sidebar from "./components/Sidebar";
import FamilyOffice from "./pages/FamilyOffice";
import ClientHoldings from "./pages/ClientHoldings";
import AssetDetails from "./pages/Assetdetailpage";
import Login from "./pages/Login";
import Resetpassword from "./pages/Resetpassword";
import CollectibleAssets from "./pages/Collectibleassets";
import Insights from "./pages/insights";
import News from "./pages/news";
import Signin from "./pages/LoginWithCode";
import Dashboard from "./pages/Dashboard";
import "./styles/layout.css";
import Orgs from "./pages/Orgs";

export default function App() {
  const location = useLocation();

  const IGNORE_PAGES = [
    "/login",
    "/reset",
    "/signin",
    "/signin/",
    "/signin/generate",
  ];

  useEffect(() => {
    const path = location.pathname;

    // ⛔ Ignore auth pages
    if (IGNORE_PAGES.includes(path)) return;

    const userId = localStorage.getItem("user_id");
    if (!userId) return;

    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    const role = roles?.[0]?.role_name;
    const userName = localStorage.getItem("user_name");

    fetch("https://schedulerapi.pricingculture.com/holdings/pageVisit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        role,
        userName,
        page: path,
        source:window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop",
      }),
    }).catch(() => {});
  }, [location.pathname]);



  // 🔐 Inline Auth Guard
  const RequireAuth = ({ children }) => {
    const isLoggedIn = localStorage.getItem("accessToken");

    if (!isLoggedIn) {
      return (
        <Navigate
          to="/signin"
          replace
          state={{ from: location }}
        />
      );
    }

    return children;
  };

  // Pages without sidebar/header
  const noSidebarPaths = ["/login", "/reset","/signin","/signin/generate","/signin/"];
  const showSidebar = !noSidebarPaths.includes(location.pathname);

  // Profile dropdown state
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (!confirmed) return;

    localStorage.clear();
    // navigate("/login", { replace: true });
    window.location.replace('https://www.pricingculture.com/collectible-assets-terminal')
  };

  return (
    <div style={{backgroundColor: "#000"}}>
      {/* 🔝 Header */}
      {showSidebar && (
        <div
          style={{
            backgroundColor: "#000",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            padding: "20px",
          }}
        >
          {/* <img
            src="https://cdn.prod.website-files.com/6704fe9ff2554866b346ff70/6949702df1e902a9654a063a_Pricing%20Culture.JPG"
            alt="Pricing Culture Logo"
            style={{ height: 40 }}
          /> */}
          <div style={{height:20}}></div>

          <div ref={dropdownRef} style={{ position: "relative" }}>
            <div
              onClick={() =>
                //  setOpen(!open)
                handleLogout()
                }
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              {/* 👤 */}

              <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z" fill="#fff"/>
                <path d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z" fill="#fff"/>
              </svg>
               
            </div>

            {/* {open && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 44,
                  backgroundColor: "#fff",
                  borderRadius: 6,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  minWidth: 140,
                  overflow: "hidden",
                }}
              >
                <div
                  onClick={handleLogout}
                  style={{
                    padding: "10px 14px",
                    cursor: "pointer",
                    fontSize: 14,
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f2f2f2")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  Logout
                </div>
              </div>
            )} */}
          </div>
          
        </div>
      )}

      {/* 🧱 Layout */}
      <div className="app-container" style={{ display: "flex",maxHeight:'90vh',  background:'#0b0b0b' }}>
        {showSidebar && <Sidebar />}

        <main className="main-content" style={{ flex: 1 }}>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signin/:type" element={<Signin />} />
            <Route path="/reset" element={<Resetpassword />} />

            {/* 🔐 Protected */}
            <Route
              path="/family-office"
              element={
                <RequireAuth>
                  <FamilyOffice />
                </RequireAuth>
              }
            />

            <Route
              path="/family-dashboard"
              element={
                <RequireAuth>
                   {/* <FamilyOffice /> */}
                 {/* <div>Family Dashboard</div> */}
                 <Dashboard />
                </RequireAuth>
              }
            />
             <Route
              path="/orgs"
              element={
                <RequireAuth>
                  <Orgs />
                </RequireAuth>
              }
            />

            <Route
              path="/client-holdings"
              element={
                <RequireAuth>
                  <ClientHoldings />
                </RequireAuth>
              }
            />

            <Route
              path="/client-holdings/details"
              element={
                <RequireAuth>
                  <AssetDetails />
                </RequireAuth>
              }
            />

            <Route
              path="/indications"
              element={
                <RequireAuth>
                  <div>Indications Page</div>
                </RequireAuth>
              }
            />

            <Route
              path="/news"
              element={
                <RequireAuth>
                  <News />
                </RequireAuth>
              }
            />

            <Route
              path="/insights"
              element={
                <RequireAuth>
                 <Insights />
                </RequireAuth>
              }
            />

            <Route
              path="/indices"
              element={
                <RequireAuth>
                  <CollectibleAssets />
                </RequireAuth>
              }
            />
          </Routes>
        </main>
      </div>
    </div>
  );
}